import MessageError from 'Components/Common/MessageError';
import React, { CSSProperties, ReactNode } from 'react';
import { Col, Form, FormGroupProps } from 'react-bootstrap';
import { labelRequire, labelRequireChip } from '../FormLabel';

interface IFormGroup extends FormGroupProps {
  children: ReactNode;
  messageError?: string;
  classLabel?: string;
  isLabelRequireChip?: boolean;
  styleLabel?: CSSProperties;
  labelMd?: number;
  labelLg?: number;
  colMd?: number;
  label?: string;
  isSubRequired?: boolean;
  subLabel?: string;
  classCol?: string;
}

const FormGroup = ({
  children,
  messageError,
  classLabel,
  classCol,
  isLabelRequireChip,
  styleLabel,
  labelMd,
  labelLg,
  colMd,
  isSubRequired,
  label,
  subLabel,
  ...rest
}: IFormGroup) => {
  return (
    <Form.Group {...rest}>
      <Form.Label className={classLabel} style={styleLabel} column md={labelMd} lg={labelLg}>
        {isLabelRequireChip && label ? (
          labelRequireChip(label, classLabel, isSubRequired)
        ) : label ? (
          labelRequire(label)
        ) : (
          <></>
        )}
        {subLabel && <p className="fs-13">{subLabel}</p>}
      </Form.Label>
      <Col md={colMd} className={classCol}>
        {children}
        {messageError && <MessageError message={messageError} />}
      </Col>
    </Form.Group>
  );
};

export default FormGroup;
